
import {
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_PAYCONFIRM,
  MULTICURRENCY_SAVECARDOFINTENT
} from "../apis/payment"

var payScript
export default {
  data() {
    return {
      user_cardId: '',
      query_timer: 0,
      query_pay_num: 0
    }
  },
  methods: {
    loadMyPOSEmbeddedScript(type, success) {
      if (!window.MyPOSEmbedded) {
        payScript = window.document.createElement('script')
        payScript.src = 'https://developers.mypos.com/repository/mypos-embedded-sdk.js'
        payScript.onload = () => {
          console.log('MyPOSEmbedded 加载完成')
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(payScript, head.firstChild)
      } else {
        console.log('mpayMyPOSEmbedded 已加载')
        success && success()
      }
    },
    // 多货币支付方式
    onMulticurrencyPayment(payMode, callback) {
      this.MulticurrencyRecharge(payMode, callback)
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(mode, callback) {
      try {
        let rechargeType = "balance";
        if (this.Query && this.Query.paymentWay.includes('PAYMENT')) rechargeType = "preAuth";
        if (this.payType === "PO") rechargeType = "pay";
        if (this.payType === "VIP") rechargeType = "vip";
        const query = {
          "paymentId": this.pId,
          "amount": this.price || "",
          "rechargeType": rechargeType,
          "userOpenId": this.user.p_openID,
          "rentNow": rechargeType === 'balance',
          "qrCode": this.qrcode || this.$route.query.cabinetID || ""
        }
        if (this.user_cardId) {
          query.rentNow = true;
          query.userCardId = this.user_cardId;
        }

        if (!query.userCardId && this.Query.paymentWay.includes('SAVED') && mode.includes('MyPosOnlinePay')) {
          return this.myPosSaveCard(callback);
        }
        const headers = { headers: { "Content-Type": "application/json;charset=UTF-8" } }
        this.$loading(true)
        const { data = {} } = await this.$Request("POST", MULTICURRENCY_RECHARGE, query, headers)
        const Payment = this.selectPayment || { paymentMethodType: '' };
        if (data.outTradeNo && query.userCardId) {
          this.$loading(false)
          const res = { orderId: data.outTradeNo, orderStatus: 1 };
          return callback && callback(res);
        }
        if (data.outTradeNo && Payment.paymentMethodType.includes('Alipay')) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        }
        if (data.outTradeNo && mode.includes('MyPosOnlinePay')) {
          this.loadMyPosOnlinePay(data.paymentInfo, callback);
          return false;
        }
        if (data.outTradeNo && data.approvalUrl) {
          window.location.href = data.approvalUrl;
          return false;
        }
        throw new Error(data.message);
      } catch (err) {
        this.$loading(false)
        this.$toast(err)
        console.warn("Multicurrency ~ err:", err)
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, Payment = {}) {
      const query = { "outTradeNo": outTradeNo || '', "tradeNo": Payment.tradeNo || '' };
      const { data = {} } = await this.$Request("GET", MULTICURRENCY_PAYCONFIRM, query)
      return data;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        return false;
      }
      const callbackCell = (result) => {
        if (result && result.orderStatus === 1) {
          this.$loading(false)
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200)
        }
      }
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment).then((result) => {
          callbackCell(result);
        }).catch((res) => {
          callbackCell(res);
        });
      }
    },
    loadMyPosOnlinePay(paymentInfo = {}, callback) {
      try {
        this.isMyPosOnlinePay = true;
        if (this.$refs.myPOSEmbeddedCheckout) {
          this.$refs.myPOSEmbeddedCheckout.innerHTML = '';
        }
        if (paymentInfo.redirectUrl) {
          window.location.href = paymentInfo.redirectUrl;
          return false;
        }
        const paymentParams = {
          // ...paymentInfo,
          sid: paymentInfo.sID,
          amount: paymentInfo.amount,
          currency: paymentInfo.currency,
          walletNumber: paymentInfo.walletNumber,
          orderID: paymentInfo.orderID,
          urlNotify: paymentInfo.uRL_Notify,
          urlOk: window.location.href,
          urlCancel: window.location.href,
          keyIndex: paymentInfo.keyIndex,
          cartItems: [{
            quantity: 1,
            article: paymentInfo.note,
            price: paymentInfo.amount,
            currency: paymentInfo.currency
          }]
        };
        if (paymentInfo.IPCmethod) paymentParams.IPCmethod = paymentInfo.IPCmethod;
        if (paymentInfo.hasOwnProperty('cardTokenRequest')) paymentParams.cardTokenRequest = paymentInfo.cardTokenRequest;
        if (paymentInfo.hasOwnProperty('paymentParametersRequired')) paymentParams.paymentParametersRequired = paymentInfo.paymentParametersRequired;
        if (paymentParams.cardTokenRequest === 1) {
          paymentParams.amount = 0;
          paymentParams.cartItems = '';
        }
        var callbackParams = {
          isSandbox: !paymentInfo.live,
          onMessageReceived: (messages) => {
            console.info('onMessageReceived', messages)
          },
          onSuccess: (data) => {
            console.log('success callback', data);
            // {"OrderID": "25041801110463489314","IPC_Trnref": 823204,"RequestSTAN": "066766",
            // "RequestDateTime": "2025-04-18 01:11:05"}
            if (data.OrderID) {
              this.$loading(true)
              this.MulticurrencyConfirm(data.OrderID, data).then((res) => {
                this.$loading(false)
                callback && callback(res);
              }).catch((res) => {
                this.$loading(false)
                callback && callback(res);
              });
            }
          },
          onError: (err) => {
            console.warn('onError', err);
          }
        };
        this.$loading(false)
        console.info(" createPayment ~ paymentParams:", paymentParams)
        window.MyPOSEmbedded.createPayment('myPOSEmbeddedCheckout', paymentParams, callbackParams);
      } catch (err) {
        console.warn("loadMyPosOnlinePay ~ err:", err)
      }
    },
    /** myPos 保存支付卡 */
    async myPosSaveCard(callback, pId = this.pId) {
      const paymentInfo = await this.saveCardOfIntent(pId);
      return this.loadMyPosOnlinePay(paymentInfo, (res) => {
        if (this.Query.paymentWay.includes('PAYMENT_SAVED_PROPAY')) {
          this.user_cardId = res.userCardId;
          this.MulticurrencyRecharge(this.payMode, callback)
        } else {
          callback && callback(res);
        }
      });
    },
    // 保存支付卡信息
    async saveCardOfIntent(paymentId) {
      this.$loading(true)
      const query = { paymentId: paymentId }
      const headers = { headers: { "Content-Type": "application/json;charset=UTF-8" } }
      const { data = {} } = await this.$Request("POST", MULTICURRENCY_SAVECARDOFINTENT, query, headers)
      this.$loading(false)
      return data || {}
    }
  }
}
